import { ComponentsProps } from '@mui/material';

export const MuiTypography: {
    defaultProps?: ComponentsProps['MuiTypography'];
} = {
    defaultProps: {
        variantMapping: {
            h2Uppercase: 'h2',
            body1: 'span',
            body2: 'span',
        },
    },
};

declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
        statusLabel: true;
        h2Uppercase: true;
    }
}
